// `register-promotion.page.tpl.html` — "Access matched candidates with Woo", the screen a
// matched-candidates link opens for someone who has not installed the extension yet.
//
// ⚠️ THE COPY IS A CONSTANT IN THE SOURCE, NOT CONTENT FROM THE SERVER. `RegisterPromotions` is
// a `Record<RegisterPromotionType, IRegisterPromotion>` with exactly one entry, and the state's
// `?type` selects from it — an unknown type logs a warning and falls back to that same entry,
// so every URL renders this. Porting it as props with no default would invent a case upstream
// does not have; porting the body as markup is what `ng-bind-html` does with it.
import type { ReactElement } from 'react'
import { PageHost } from '../auth/PageHost.tsx'
import { asset } from '../assetBase.ts'

/** `RegisterPromotionType` — one member, and the fallback for anything else. */
export const REGISTER_PROMOTION_AUTO_MATCH = 'autoMatch'

export interface RegisterPromotionPageProps {
  /**
   * The Chrome Web Store URL for the extension the visitor should install.
   *
   * ⚠️ UPSTREAM BUILDS IT FROM `careero.extensionId`, WHICH IS THE LEGACY ITEM'S ID — the same
   * value CLAUDE.md constraint 6 warns about for messaging. Here the id is resolved by
   * `extensionTarget`, so a build that knows its own id links to its own store item and only
   * falls back to the tenant's when it does not. The link is the one thing on this screen that
   * has to be right: it is what the visitor installs.
   */
  storeUrl?: string
}

export function RegisterPromotionPage({ storeUrl }: RegisterPromotionPageProps): ReactElement {
  return (
    <PageHost name="chrome-extension-register-promotion-page">
      <img className="logo" src={asset('/static/assets/img/woo/logo.svg')} alt="" />
      <div className="title">Access matched candidates with Woo</div>
      {/* `ng-bind-html` with `ng-class="::ctrl.promotion.styleClass"` — the class is on the
          same div as the bound HTML, so the body is this div's children rather than a wrapper
          inside it. */}
      <div className="message message-auto-match">
        <div>To view candidate matches, you’ll need to:</div>
        <ol>
          <li>Install the Woo Chrome Extension</li>
          <li>Register for a Woo account</li>
        </ol>
      </div>
      {/* `ng-href` with `target="_blank"`. Upstream adds no `rel`; the store is a first-party
          destination and the attribute is part of what the selectors and the reference see. */}
      <a className="btn btn-primary register-btn" href={storeUrl} target="_blank" rel="noreferrer">
        Install extension &amp; register
      </a>
    </PageHost>
  )
}
